import { Box, Modal, Typography } from '@mui/material';
import { MachineType } from '../Dashboard/CreateEditMachineGroupForm';

type Params = {
  showModal: boolean;
  machineType: string;
  closeModal: () => void;
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function BulkInsertFileInfo({ showModal, machineType, closeModal }: Params) {
  return (
    <Modal
      open={showModal}
      onClose={() => closeModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle}>
        <Typography variant="h6" component="h2">
          {machineType} csv file columns
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{ mt: 2, fontSize: '=2em' }}
        >
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            1. PartNumber - <b>required</b>, max length 40 characters
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            2. PresetDescription - optional
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            3. Barcode - <b>required</b>, max length 40 characters
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            4. BarcodeDescription - optional
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            5. Length - <b>required</b>, value between 0 and 999.999
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            6. Width - <b>required</b>, value between 0 and 999.999
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            7. Depth - <b>required</b>, value between 0 and 999.999
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            8. StepText - optional, defaults to
            <i>&apos;Step #&apos;</i>, max length 75 characters
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            9. BoxType - optional
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            10. BoxDescription - optional
          </Typography>
          <Typography
            variant="body1"
            component="p"
            sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
          >
            11. DelayType - optional, defaults to
            <i>&apos;Manually-Sequenced&apos;</i>, other possible values:{' '}
            <i>&apos;Delay&apos;</i>
          </Typography>
          {machineType === MachineType[MachineType.SmartBagger] ? (
            <>
              <Typography
                variant="body1"
                component="p"
                sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
              >
                12. Delay -{' '}
                <b>
                  required if DelayType is <i>&apos;Delay&apos;</i>
                </b>
                , value between 0 and 30.9
              </Typography>
              <Typography
                variant="body1"
                component="p"
                sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
              >
                13. StepType - optional, defaults to
                <i>&apos;Bag&apos;</i>, other possible values:{' '}
                <i>&apos;None&apos;</i>
              </Typography>
              <Typography
                variant="body1"
                component="p"
                sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
              >
                14. BagLength -{' '}
                <b>
                  required if StepType is <i>&apos;Bag&apos;</i>
                </b>
                , value between 10 and 70
              </Typography>
              <Typography
                variant="body1"
                component="p"
                sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
              >
                15. BagFill -{' '}
                <b>
                  required if StepType is <i>&apos;Bag&apos;</i>
                </b>
                , value between 20 and 100
              </Typography>
            </>
          ) : (
            <>
              <Typography
                variant="body1"
                component="p"
                sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
              >
                12. Delay -{' '}
                <b>
                  required if DelayType is <i>&apos;Delay&apos;</i>
                </b>
                , value between 0 and 30.0
              </Typography>
              <Typography
                variant="body1"
                component="p"
                sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
              >
                13. Operation - optional, defaults to
                <i>&apos;Pad&apos;</i>, other possible values:{' '}
                <i>&apos;None&apos;</i>
              </Typography>
              <Typography
                variant="body1"
                component="p"
                sx={{ fontSize: '1.1em', marginBottom: '0.4em' }}
              >
                14. PadLength -{' '}
                <b>
                  required if Operation is <i>&apos;Pad&apos;</i>
                </b>
                , value between 6 and 999
              </Typography>
            </>
          )}
        </Typography>
      </Box>
    </Modal>
  );
}

export default BulkInsertFileInfo;
